import { render, staticRenderFns } from "./UpdateSeriesOfProducts.vue?vue&type=template&id=4ee1db01&scoped=true"
import script from "./UpdateSeriesOfProducts.vue?vue&type=script&lang=js"
export * from "./UpdateSeriesOfProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1db01",
  null
  
)

export default component.exports